import { Component } from '@angular/core';
import './rxjs-operators';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app works!';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts